// import {prepend} from 'ramda'
// import {useEffect} from 'react'

export const DropdownItem = ({item, team, setTeam, handleSelect}) => {
    const {name} = item
    const handleClick = () => {
        setTeam(team.concat(item))
        handleSelect(name)
    }
    return (
        <span className="dropdown-item" onClick={handleClick}>
            {name}
        </span>
    )
}